/* MolCellQuest — 「あとで解き直す」
   ──────────────────────────────────────────────────────────
   アカウント登録者限定の機能。理由は2つ。
     1. 印はクラウドに同期されて初めて価値が出る（別の端末・試験前に開く）
     2. 登録の動機になる
   進捗そのものは未登録でもローカルに残るので、ここだけを絞る。

   progress.review は problemId -> タイムスタンプ。
   正の値＝印あり、負の値＝外した記録。詳細は state.svelte.js を参照。
   ────────────────────────────────────────────────────────── */

import { progress, save } from "./state.svelte.js";
import { auth } from "./authState.svelte.js";
import { CURRICULUM } from "../../data/problems/index.js";

/** この機能を使えるか */
export function canUseReview() {
  return !!auth.user;
}

export function isMarked(id) {
  return (progress.review?.[id] || 0) > 0;
}

/** 印を付け外しする。@returns {boolean} 操作後に印が付いているか */
export function toggleMark(id) {
  if (!id || !canUseReview()) return false;
  const on = !isMarked(id);
  progress.review[id] = on ? Date.now() : -Date.now();
  save();
  return on;
}

export function unmark(id) {
  if (!id || !canUseReview()) return;
  if (isMarked(id)) {
    progress.review[id] = -Date.now();
    save();
  }
}

/** 印を付けた問題（新しい順）。存在しない id は捨てる。 */
export function markedProblems() {
  const r = progress.review || {};
  return CURRICULUM.filter((p) => (r[p.id] || 0) > 0).sort((a, b) => r[b.id] - r[a.id]);
}

export function markedCount() {
  return markedProblems().length;
}
